module.exports = __webpack_public_path__ + "img/reset.7a60a159.jpg";